/*
 * Contact Messages
 *
 * This contains all the text for the Contact component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Contact.title',
    defaultMessage: 'Contact',
  },
});
